import { Injectable } from "@angular/core";
import { FieldGroupMetadata, FieldMetaDefaults, FieldMetadata, TabMetadata, ViewMetadata } from "../cer-data/cer-data-types";
import { CerDataService } from "@data/cer-data.service";
import { ColumnModel } from "@syncfusion/ej2-angular-grids";
import { CerSessionService } from "@cer/cer-session/cer-session.service";

@Injectable()
export class CerDataMetaService {

  constructor(private data: CerDataService, private session: CerSessionService) {
  }

  public viewMetadata: ViewMetadata = null;
  public fieldMetadata: FieldMetadata[] = null;
  public fieldGroupMetadata: FieldGroupMetadata[] = null;
  public tabMetadata: TabMetadata[] = null;

  init(viewMeta: ViewMetadata, fieldMeta: FieldMetadata[], fieldGroupMeta: FieldGroupMetadata[], tabMeta: TabMetadata[]) : FieldMetadata[] {
    this.viewMetadata = viewMeta;
    this.fieldMetadata = FieldMetaDefaults.metaInit(viewMeta, fieldMeta);
    this.viewMetadata.fieldMetaData = fieldMeta;
    this.fieldGroupMetadata = fieldGroupMeta;
    this.tabMetadata = tabMeta;
    this.applyDictionary();
    this.data.initFromMeta(viewMeta, fieldMeta);
    return this.fieldMetadata;
  }

  private applyDictionary() {
    const entityName = this.viewMetadata?.dataApiName;
    const entity = this.session.user.entityByName(entityName);
    if (entity) {
      this.fieldMetadata?.forEach(f => {
        const column = this.session.user.columnByName(entity,f.name);
        const maxLength = column?.attributes?.maxLength;
        if (maxLength > 0) {
          f.validationMaxLen = maxLength;
        }
      });
    }
  }

  public fieldMetaGet(fieldName: string): FieldMetadata {
    return this.data.fieldMetadata.find(f => f.name == fieldName);
  }

  public columnMetaGet(column: ColumnModel): FieldMetadata {
    return column ? (<any>column).meta : null;
  }

  public isFieldVisible(c: ColumnModel, isAdd: boolean): boolean {
    var visible: boolean = c.visible !== false;
    var meta = this.columnMetaGet(c);
    if (meta) {
      if (isAdd) {
        if (meta.visibleAdd === true) {
          visible = true;
        }
        if (meta.visibleAdd === false) {
          visible = false;
        }
      }
      else {
        if (meta.visibleEdit === true) {
          visible = true;
        }
        if (meta.visibleEdit === false) {
          visible = false;
        }
      }
      if (meta.currentRowVisible === true) {
        visible = true;
      }
      if (meta.currentRowVisible === false) {
        visible = false;
      }
    }
    return visible;
  }
}
